import {useEffect} from 'react'
import { Grid } from "@mui/material"
import Header from '../login-register/components/header';

const BlogsPage = (props) => {

    useEffect(() => {
        document.title = "Blogs";
      }, []);

    return (
        <>
            {props.dontShowHeader ? null : <Header showLogin={true} showIntro={true} />}
            <Grid component="main" container display="flex" flexDirection="column" justifyContent="center" alignItems="center" sx={{ height: `calc(100vh - 64px)` }}>
                <h1>This Page is Under Construction</h1>
            </Grid>
        </>
    )
}

export default BlogsPage;
